import React from "react";
import { Snackbar, Alert, AlertColor, AlertTitle } from "@mui/material";

type SharedAlertProps = {
  open: boolean;
  onClose: () => void;
  severity?: AlertColor;
  message: string;
  title?: string;
  autoHideDuration?: number;
};

export const SharedAlert: React.FC<SharedAlertProps> = ({ open, onClose, severity = "info", message, title, autoHideDuration = 4000 }) => {
  return (
    <Snackbar open={open} autoHideDuration={null} onClose={onClose} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
      <Alert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </Snackbar>
  );
};
